import type { FC } from 'react';
import React, { useState } from 'react';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { message } from 'src/common/components/message';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import type { FilePreviewProps } from '.';

export const AudioPreviewCom: FC<FilePreviewProps> = ({ downloadUrl }) => {
  const { t } = useAppTranslation();
  const [errorMsg, setErrorMsg] = useState('');
  // return (

  //   <audio controls src={downloadUrl}>
  //     当前浏览器不支持<code>audio</code> 元素。
  //   </audio>
  // );
  return (
    <AudioPlayer
      autoPlay={false}
      preload="none"
      autoPlayAfterSrcChange={false}
      src={downloadUrl}
      onError={(e) => {
        const { error } = e.target as any;
        if (!error || !downloadUrl) {
          return;
        }
        switch (error.code) {
          case MediaError.MEDIA_ERR_DECODE:
            setErrorMsg(t('file_preview_components.audio.decode_error'));
            break;
          case MediaError.MEDIA_ERR_NETWORK:
            setErrorMsg(t('file_preview_components.audio.load_failed'));
            break;
          case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
            setErrorMsg(t('file_preview_components.audio.unsupported_format'));
            break;
          default:
        }
      }}
      onPlayError={(err) => {
        if (errorMsg) {
          message.warning({
            key: errorMsg,
            content: errorMsg,
          });
        } else {
          message.warning({
            key: err.message,
            content: err.message,
          });
        }
      }}
    />
  );
};

export const AudioPreview = React.memo(AudioPreviewCom);
